import * as React from 'react';
import BaggageBodyCore from '@websky/core/src/Baggage/UpgradeBaggageDialog/components/BaggageBody/BaggageBody';
import { useSelector } from 'react-redux';
import { getBaggageTab } from '@websky/core/src/Baggage/UpgradeBaggageDialog/store/selector';
import Notification from '@websky/core/src/Notification';
import { InfoMessageTypeEnum } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
const WZ_PET_RFICS = ['0BT', '021', '0BS', '0AY'];
const BaggageBody = props => {
    const baggageTab = useSelector(getBaggageTab);
    const isShowZiaPetControlNoticeForRegWings = props.segments.some(segment => { var _a, _b; return ((_b = (_a = segment.departure) === null || _a === void 0 ? void 0 : _a.airport) === null || _b === void 0 ? void 0 : _b.iata) === 'ZIA'; }) && WZ_PET_RFICS.includes(baggageTab);
    const { t } = useTranslation('Baggage');
    return (React.createElement(React.Fragment, null,
        React.createElement(BaggageBodyCore, Object.assign({}, props)),
        isShowZiaPetControlNoticeForRegWings && (React.createElement(Notification, { status: InfoMessageTypeEnum.Warning, type: "context", infoMessage: {
                text: t('ZIA_pet_control_warning'),
                type: InfoMessageTypeEnum.Warning,
                code: ''
            } }))));
};
export default BaggageBody;
